import classNames from 'classnames';
import Icon from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import Link from '@/components/utilities/link/link';
import styles from './transports-selector-item.module.scss';

export interface TransportsSelectorItemProps {
  /** The class name to apply */
  className?: string;
  /** The icon to show */
  icon: IconName;
  /** The label for the option */
  label: string;
  /** The state of the item */
  state?: 'active' | 'default' | 'disabled';
  /** Optional decoration text */
  tag?: string;
  /** The text for the item */
  text?: string;
  /** The url to the new offers */
  url: string;
}

const TransportsSelectorItem = ({
  className,
  icon,
  label,
  url,
  state = 'default',
  tag,
  text,
}: TransportsSelectorItemProps) => (
  <Link
    aria-label={label}
    className={classNames(styles.component, className, {
      [styles.isActive]: state === 'active',
      [styles.isDisabled]: state === 'disabled',
    })}
    url={url}
  >
    {icon && <Icon name={icon} size={16} />}

    {tag && (
      <Typography className={styles.tag} tagStyle="labelSmall">
        {tag}
      </Typography>
    )}

    <div className={styles.content}>
      <Typography className={styles.label} tagStyle="bodyMediumBold">
        {label}
      </Typography>

      {text && (
        <Typography className={styles.text} tagStyle="bodyMedium">
          {text}
        </Typography>
      )}
    </div>
  </Link>
);

TransportsSelectorItem.displayName = 'TransportsSelectorItem';

export default TransportsSelectorItem;
